import { CircleText, QuestionDisplayMode } from '@doltech/ui/lib/figma/CircleText/CircleText';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ReadingText } from '@doltech/ui/lib/figma/Typography';
import { QUESTION_NO_WRAPPER_MARGIN_BOTTOM } from '@doltech/utils/lib/constants';
import { numberToABC } from '@doltech/utils/lib/text';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { SingleAnswerMain } from '../../../student-do-test-questions/SingleAnswer';
import { DoTestMultipleAnswerQuestionInstance } from '../../../student-do-test/model/Question/do-test-multiple-answer-question.store';

interface MultipleAnswerSubjectProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestMultipleAnswerQuestionInstance;
}

const CircleTextWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

const Main = styled(SingleAnswerMain)`
  .question-no-wrapper {
    margin-bottom: ${QUESTION_NO_WRAPPER_MARGIN_BOTTOM}px;
  }
  .question-option-wrapper {
    padding: 8px 0;
  }
  box-shadow: unset;
  border: unset;
  pointer-events: none;
`;

const ReadingTextWrapper = styled.div`
  margin-bottom: 24px;
  .reading-text {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: ${colorsV2.black100};
  }
`;

export const MultipleAnswerSubject = observer((props: MultipleAnswerSubjectProps) => {
  const { data, ...rest } = props;
  const { question, options } = data;

  return (
    <Main className="dol-question" {...rest}>
      <ReadingTextWrapper>
        <ReadingText>{question}</ReadingText>
      </ReadingTextWrapper>
      {options.map((option, index) => {
        const { key, value } = option;
        return (
          <CircleTextWrapper key={key}>
            <CircleText
              className="question-option-wrapper"
              circleText={numberToABC(index + 1)}
              displayMode={QuestionDisplayMode.QUESTION_OPTION_VIEW_SUBJECT}
              text={value}
            />
          </CircleTextWrapper>
        );
      })}
    </Main>
  );
});
